import { compose } from "redux";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import React, { PureComponent } from "react";
import { Grid, Button } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";

import routePaths from "app/routePaths";
import { getInitials } from "utils/app.util";
import { CardMapper } from "features/planner/planner.mappers";
import EntityDetailsHeader from "app/components/EntityDetailsHeader";
import { getEmployeeCardFromState } from "features/planner/employee/employee.selectors";
import { EMPLOYEE_CARD_HASH_TARGET } from "features/planner/employee/employee.constants";

class EmployeeHeader extends PureComponent {
  render() {
    const { classes, children, employeeCard } = this.props;

    return (
      <EntityDetailsHeader
        subtitle={employeeCard.get("groupName")}
        title={employeeCard.getIn(["employee", "displayName"])}
        Icon={getInitials(employeeCard.getIn(["employee", "displayName"]))}
        classes={{
          root: classes.headerRoot,
        }}
      >
        <Grid xs item container spacing={2} wrap="nowrap" alignItems="center">
          <Grid item>{children}</Grid>
          <Grid item>
            {window.location.hash === EMPLOYEE_CARD_HASH_TARGET ? (
              <Button
                color="secondary"
                onClick={window.close}
                className={classes.headerButton}
              >
                Close
              </Button>
            ) : (
              <Link to={routePaths.root}>
                <Button color="secondary" className={classes.headerButton}>
                  Close
                </Button>
              </Link>
            )}
          </Grid>
        </Grid>
      </EntityDetailsHeader>
    );
  }
}

EmployeeHeader.defaultProps = {
  employeeCard: CardMapper.initial(),
};

const styles = theme => ({
  headerButton: {
    textTransform: "none",
    background: `${theme.palette.grey[200]}90`,
    fontWeight: theme.typography.fontWeightBold,
    color: ({ employeeCard }) =>
      employeeCard && employeeCard.get("qualificationColor")
        ? theme.palette.getContrastText(employeeCard.get("qualificationColor"))
        : null,
  },
  headerRoot: {
    color: ({ employeeCard }) =>
      employeeCard && employeeCard.get("qualificationColor")
        ? theme.palette.getContrastText(employeeCard.get("qualificationColor"))
        : null,
    backgroundColor: ({ employeeCard }) =>
      employeeCard && employeeCard.get("qualificationColor")
        ? employeeCard.get("qualificationColor")
        : null,
  },
});

export default compose(
  connect((state, { employeeCardId }) => ({
    employeeCard: getEmployeeCardFromState(state, employeeCardId),
  })),
  withStyles(styles),
)(EmployeeHeader);
